<template>
    <modal :name="modalName" width="100%" height="auto">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t("Change how you order") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    v-on:click="$modal.hide(modalName)">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <ul class="list-unstyled">
                    <template v-for="(details, key, index) in variants">
                        <li :key="key" v-on:click="variant = key"
                            v-if="enabledMenus[key.replace(new RegExp('-', 'g'), '_')]">
                            <div class="radio form-check form-check-inline">
                                <input class="form-check-input" v-model="variant" name="variant-cb" type="radio"
                                    :id="`${key}-cb`" :value="key" :checked="key == variant">
                                <label class="form-check-label" :for="`${key}-cb`">{{ details.name }}
                                    <br>
                                    <router-link class="text-muted form-text form-style font-italic cursor-pointer"
                                        v-if="original == 'click-and-collect' && key == original"
                                        :to="`/${siteSlug}/select-slot`" v-on:click.native="$modal.hide(modalName)">
                                        {{ pickUpTime }}
                                        (<span class="text-success"><u>{{ $t("Edit") }}</u></span>)
                                    </router-link>

                                </label>
                            </div>
                        </li>
                        <hr v-if="index < (Object.keys(variants).length - 1)" :key="`hr-${key}`">
                    </template>
                </ul>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-close" v-on:click="$modal.hide(modalName)">{{ $t("Close") }}</button>
                <button type="button" class="btn btn-primary" v-on:click="apply">{{ $t("Save changes") }}</button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['modalName', 'siteSlug'],
    data() {
        return {
            variants: window.app.variants,
            variant: window.app.cart?.variant,
            original: window.app.cart?.variant,
            enabledMenus: window.app.enabled_menus,
            pickUpTime: window.app.cart?.extra?.slot_text
        }
    },
    methods: {
        apply() {
            if (this.variant == this.original) {
                return this.$modal.hide(this.modalName);
            }

            window.location = `/${this.siteSlug}/${this.variant}`;
        }
    }
}
</script>
